import i18next from "i18next";
import { useEffect, useState } from "react";
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { FEATURES, hasFeatureAccess } from "../helpers/featureAccess";

/** Admin-only view switch. League/season/round/fixture state stays in the parent.
 * No URL, route or persisted preference can opt into the experimental view. */
export function LeagueMatchdayEntry({ user, disabled = false, children }) {
  const allowed = hasFeatureAccess(FEATURES.LEAGUE_MATCHDAY_ENTRY_TEST, user);
  const userId = String(user?.user_id ?? user?.email ?? user?.id ?? "");
  const [testOwner, setTestOwner] = useState(() => allowed ? userId : null);
  const testActive = allowed && testOwner === userId;

  useEffect(() => {
    setTestOwner(allowed ? userId : null);
  }, [allowed, userId]);

  return (
    <Box
      data-testid="league-matchday-entry"
      data-view={testActive ? "test" : "legacy"}
      sx={{ minWidth: 0 }}
    >
      {allowed && (
        <ToggleButtonGroup
          exclusive
          size="small"
          value={testActive ? "test" : "legacy"}
          aria-label="Liga-Ansicht"
          disabled={disabled}
          onChange={(_, value) => {
            if (!allowed || disabled || !value) return;
            setTestOwner(value === "test" ? userId : null);
          }}
          sx={{ mb: 0.5 }}
        >
          <ToggleButton value="legacy">
            {i18next.t("help.adminLeague.oldView", {
              defaultValue: "Bisherige Liga-Ansicht",
            })}
          </ToggleButton>
          <ToggleButton value="test">
            {i18next.t("help.adminLeague.newView", {
              defaultValue: "Neue Liga-Arbeitsansicht",
            })}
          </ToggleButton>
        </ToggleButtonGroup>
      )}
      {typeof children === "function" ? children(testActive) : children}
    </Box>
  );
}
